import { useEffect, useState } from "react";

import styled from "styled-components";
import { useGlobaleContext } from "../context";

const Paginate = () => {
  const { featured_projects, setPaginated_projects, showPerPage } =
    useGlobaleContext();
  const [page, setPage] = useState(0);
  const [page_Btns, setPageBtns] = useState([]);

  //getting the amount of users inside  the tbody
  const number_of_items = featured_projects.length;

  //calculate the number of pages we are going to have
  const number_of_pages = Math.ceil(number_of_items / showPerPage);

  // display new page project
  useEffect(() => {
    const start_from = page * showPerPage;
    const end_on = start_from + showPerPage;
    const tmp = featured_projects.slice(start_from, end_on);

    setPaginated_projects(tmp);
    // eslint-disable-next-line
  }, [page]);

  const handlePage = (index) => {
    setPage(index);
  };
  const prevPage = () => {
    setPage(() =>
      page === 0 ? number_of_pages - 1 : (page - 1) % (number_of_pages - 1)
    );
  };
  const nextPage = () => {
    setPage(() => (page + 1) % number_of_pages);
  };

  // dispaly pagination btns

  useEffect(() => {
    const tmp = [];
    for (
      let currentLink = 0;
      currentLink < Math.ceil(featured_projects.length / showPerPage);
      currentLink++
    ) {
      tmp.push(
        <button
          key={currentLink}
          className={currentLink === page ? "btn active" : "btn"}
          onClick={() => handlePage(currentLink)}
        >
          {" "}
          {currentLink + 1}
        </button>
      );
    }

    setPageBtns(tmp);
  }, [featured_projects, page, showPerPage]);

  return (
    <Wrapper>
      <button className=" btn--transparent" onClick={() => prevPage()}>
        &lt;
      </button>
      {page_Btns}
      <button className="btn--transparent" onClick={() => nextPage()}>
        &gt;
      </button>
    </Wrapper>
  );
};

const Wrapper = styled.div`
  button {
    width: 32px;
    height: 32px;
  }
  .btn {
    font-size: 1rem;
    padding: 0;
    margin: 0 !important;
    &--transparent {
      background: transparent none repeat scroll 0% 0%;
      border: 1px solid var(--colors-accent-50);
      cursor: pointer;
    }
  }
  .active {
    border-color: var(--clr-grey-1);
  }
  @media (max-width: 635px) {
    button {
      font-size: 2rem !important;
      width: 48px;
      height: 48px;
    }
  }
`;

export default Paginate;
